import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RefundLine, RefundModel } from 'src/app/models/refund.model';
import { ReturnDbService } from 'src/app/services/data/return-db.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-refund-list-item',
  templateUrl: './refund-list-item.component.html',
  styleUrls: ['./refund-list-item.component.scss'],
})
export class RefundListItemComponent implements OnInit {
  @Input() refund!: RefundModel;
  @Output() refundChange = new EventEmitter<RefundModel>();
  private readonly router = inject(Router)
  private refundService?: ReturnDbService;
  
  itemsMinus = false;
  refunds1cTotal = 0;
  constructor(private readonly cm: ConnectionManagerService) {
    this.refundService = new ReturnDbService(cm.getCurrentDb());
  }

  ngOnInit(): void {
    this.refund.warn = this.count1cWarnings(this.refund);

    this.refund.totalAmount = this.refund.items
      ?.map((i) => i.amount)
      .reduce((sum, val) => sum + val, 0);
    this.refund.summa = this.refund.items
      ?.map((i) => i.summa)
      .reduce((sum, val) => sum + val, 0);

    if (this.refund.orders1c && this.refund.orders1c.length) {
      this.refund.orders1c.forEach((ref1c) => {
        ref1c.amount = this.refund.items
          ?.filter((x) => x.order1cId === ref1c.id)
          .map((x) => x.amount1C)
          .reduce((a, b) => a + b, 0);
        this.refunds1cTotal += ref1c.amount;

        ref1c.summa = this.refund.items
          ?.filter((x) => x.order1cId === ref1c.id)
          .map((x) => x.summa1C)
          .reduce((a, b) => a + b, 0);
      });

      if (this.refunds1cTotal !== this.refund.totalAmount) {
        this.itemsMinus = true;
      }
    }
  }
  private count1cWarnings(refund: RefundModel) {
    if (!refund.orders1c || !refund.orders1c.length) {
      return false;
    }

    return refund.orders1c.find((x) => x.note?.trim()) ? true : false;
  }

  check1cItems() {
    const allitems = this.refund?.items?.length;
    const items1c = this.refund?.items?.filter((x) => x.order1cId).length;
    const state =
      this.refund.statusId === 1 ||
      this.refund.statusId === 2 ||
      this.refund.statusId === 11;
    if (items1c !== allitems && !state) return true;

    return false;
  }

  checkItemslength() {
    const items1c = this.refund?.items?.filter((x) => x.order1cId).length;
    if (!items1c) return true;
    return false;
  }

  copyRefund(refund: RefundModel, allitems = true): void {

    if (!this.refund) { return }
    let items: RefundLine[] = []
    if (allitems) {
      items = refund.items?.map(x => { return { amount: x.amount, good: x.good, goodId: x.goodId, summa: x.summa, price: x.price } as RefundLine })
    }
    else {
      items = refund.items?.filter(x => x.amount1C === 0 || x.price1C === 0 || x.summa1C === 0).map(x => { return { amount: x.amount, good: x.good, goodId: x.goodId, summa: x.summa, price: x.price } as RefundLine })
    }

        const copy = {
      id: '',
      agent: refund.agent,
      agentId: refund.agentId,
      buypoint: refund.buypoint,
      buypointId: refund.buypointId,
      date: new Date(),
      dateDelivery: undefined, // да, undefined
      deliveryComment: `Копия ${refund.number ?? ''} ${refund.deliveryComment}`,
      filialId: refund.filialId,
      filial: refund.filial,
      firm: refund.firm,
      firmId: refund.firmId,
      items: items,
      statusId: 1,
      summa: refund.items?.map(x => x.price * x.amount).reduce((a, b) => a + b, 0),

      vendorId: refund.vendorId
    } as RefundModel

    this.refundService?.createRefund(copy)
      .subscribe({
        next: (refund) => {
          this.router.navigate(['/edit-refund', refund.id])
        },
        error: (serror) => {

          //  this.loading = false
          //   this.snack.open(serror, 'ok', { duration: 3800 })
        },
      })
  }


}
